module.exports = "/app/themes/skideal/dist/images/edit-pen.svg?a89e30806a456f471b3553e77b614104";